import Vue from 'vue'
let vue = new Vue()
let baseUrl = vue.$cdn

export default{
  intro: [
    {
      name: '',
      txt: [
        'In June 2017, 4DAGE and German Research Center for Artificial Intelligence initiated CGAII, the signing ceremony of which was witnessed by the Chinese Premier and German Chancellor. Supported by technological competence from the two countries, CGAII strongly facilitates the research and application of AI vision.',
        'As the phased product in this Chinese-German cooperation project, 4DKanKan Pro has broken into the industry monopolized by American tech enterprises with its latest technology, and greatly reduced the costs and time of 3D modeling.',
        'Before 4DKanKan Pro, CGAII has launched the world’s first consumer 3D Camera 4DKanKan Lite in May, 2018.'
      ],
      img: baseUrl + 'images/cgaii-logo-en.png'
    },
    {
      name: '',
      txt: [
        'Since 4DAGE was founded in 2014, it has been dedicated to the studies and application of artificial intelligence in the field of three-dimensional digital reconstruction. With the vision of “digital everything”, it is bringing digital technologies to the everyday life of common people.',
        '4DAGE is one of the first 3D digital reconstruction centers in China, and one of the pioneer domestic companies to provide 3D display technologies. It has developed the proprietary technology of precise 3D digital scanning and reconstruction, the accuracy of which is improved to micron scale, and the efficiency of which is 200 times higher than traditional 3D reconstruction methods, outstripping the centimeter-scale precision achieved by Adobe Systems in the US. Only two organizations meet the requirement of such accuracy--one is 4DAGE; the other is the MIT computer vision laboratory. ',
        '4DAGE provides products and solutions not only for major museums and expositions at home and abroad, namely the Palace Museum, Nanchang Han Dynasty Haihunhou Historic Site Museum, World Expo, etc., but also significant national projects such as the virtual reality reconstruction for Hong Kong-Zhuhai-Macao Bridge. It serves industries ranging from industrial intelligence and smart city, to real estates and new retail.'
      ],
      img: baseUrl + 'images/4dage-logo-en.png'

    }
  ],
  events: {
    title: 'Chronicle',
    nodes: [
      {
        year: '2014',
        txt: [
          '<i>2014.10</i>4DAGE was founded in October 2014. The founder and senior management are returnees with European doctor\'s or master\'s degrees. They are world leaders in scientific research on AI digital 3D reconstruction and digital virtual display technology.',
          '<i>2014.12</i>4DAGE was granted a patent for a raster scanning digital 3D object reconstruction device with micron-level modeling accuracy.'
        ]
      },
      {
        year: '2015',
        txt: [
          '<i>2015.08</i>4DAGE, in competition with over 27,000 enterprises, won the China Innovation and Entrepreneurship Competition\'s Outstanding Enterprise Award.',
          '<i>2015.10</i>Dr. Cui Yan, founder of 4DAGE, was received by Premier Li Keqiang and commended to him for his work as a representative of the national "Mass Entrepreneurship and Innovation" initiative.',
          '<i></i>Became partner of organizations that preserves cultural heritage, including the Palace Museum and Guangdong Provincial Museum.'
        ]
      },
      {
        year: '2016',
        txt: [
          '<i>2016.05</i>Nanchang Han Dynasty Haihunhou Historic Site Museum\'s online digital museum was officially launched. The Han Dynasty Haihunhou Historic Site is one of the top ten national archaeological discoveries.'
        ]
      },
      {
        year: '2017',
        txt: [
          '<i>2017.04</i>4DAGE became sole virtual reality technology supplier to the China Pavilion at Kazakhstan\'s Astana World Expo.',
          '<i>2017.06</i>4DAGE and German Research Center for Artificial Intelligence signed an Agreement on the China-Germany Artificial Intelligence Institute Project witnessed by the Chinese Premier and Chancellor of Germany, creating a platform for China-Germany cooperation and exchange and establishing a strong foundation for Sino-German scientific and technological exchange.'
        ]
      },
      {
        year: '2018',
        txt: [
          '<i>2018.05</i>4DKanKan, the world\'s first consumer 3D camera was launched, capable of reconstructing 100㎡ of space in five minutes – one twentieth of the time required for image acquisition by existing machines – and costing one-tenth the price of traditional 3D modeling equipment.',
          '<i>2018.11</i>4DKanKan was recognized as “Scientific and Technological Achievement” by China High-tech Industrialization Association',
          '<i></i>4DKanKan was evaluated as “Excellent Product” by China Hi-Tech Fair.'
        ]
      },
      {
        year: '2019',
        txt: [
          '<i>2019.04</i>4DAGE cooperated with Hetjens German Museum of Ceramics in 3D digitization, and developed a digital museum application. As an outstanding case of the Belt and Road Initiative\'s cultural output, the project was included in the case collection of the 2019 Belt and Road Forum.',
          '<i>2019.05</i>4DKanKan Pro was unveiled at Rise of AI Conference in Berlin, Germany.'
        ]
      }
    ]
  },
  kefu: [
    {
      title: 'Contact Us',
      class: 'lxwm',
      content: [
        'Zhuhai 4DAGE Technology Co., Ltd',
        'Building 11, Tech Bay, Harbour Road, Hi-tech Zone, Zhuhai, Guangdong'
      ]
    },
    {
      title: 'Customer Services',
      class: 'khfw',
      content: ['Tel: 4006698025', 'E-mail: service@4dage.com']
    },
    {
      title: 'Media Inquiries',
      class: 'mtcx',
      content: ['E-mail: pr@4dage.com']
    },
    {
      title: 'Business Collaboration',
      class: 'ywhz',
      content: ['Tel: 0756-6996796 / 6996791', 'E-mail: sales@4dage.com']
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/language/en/about.js